import { useSearchParams } from "@/hooks/useSearchParams";
import { usePathname, useRouter } from "@/i18n/routing";
import { useLocale } from "next-intl";
import { Suspense } from "react";
import CustomSelect from "../ui/CustomSelect";

export const LanguageSelect = () => {
  const router = useRouter();
  const pathName = usePathname();
  const locale = useLocale();
  const searchParams = useSearchParams();

  const handleLanguageChange = (newLocale: string) => {
    router.replace(
      `${pathName}?locale=${newLocale}&${searchParams.toString()}`,
      { locale: newLocale }
    );
    router.refresh();
  };

  return (
    <Suspense>
      <CustomSelect
        options={[
          {
            label: "EN",
            value: "en",
          },
          {
            label: "AR",
            value: "ar",
          },
        ]}
        size="sm"
        value={{
          label: locale == "en" ? "EN" : "AR",
          value: locale == "en" ? "en" : "ar",
        }}
        onChange={(option) => {
          if (option) {
            handleLanguageChange(option.value!);
          }
        }}
        className="!border-none"
      />
    </Suspense>
  );
};
